import { VueQueryPlugin } from '@tanstack/vue-query'
import {
  Alert,
  Affix,
  AutoComplete,
  Avatar,
  Badge,
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Collapse,
  DatePicker,
  Divider,
  Dropdown,
  Drawer,
  Empty,
  Form,
  FloatButton,
  Flex,
  Image,
  Menu,
  Modal,
  Pagination,
  Popover,
  Popconfirm,
  Progress,
  Radio,
  Segmented,
  Select,
  Skeleton,
  Slider,
  Spin,
  Switch,
  Steps,
  Tag,
  Timeline,
  Tooltip,
  Tree,
  Typography,
  ConfigProvider,
  Input,
  InputNumber,
  Table,
  Tabs,
  Tour,
  Upload,
} from 'ant-design-vue'

import 'ant-design-vue/dist/reset.css'
import 'virtual:uno.css'
import { createPinia } from 'pinia'
import { LogArgument } from 'rollbar'
import { createApp } from 'vue'
import useQueryParamPlugin from 'vue-use-query-param'

import { initializeAuth } from '@/composables/auth'
import { getEnvFromUrl } from '@/utilities/env'

import App from './App.vue'
import { router } from './router/router'
import { queryClient } from './services/queryClient'
import { rollbar, ignoredRollbarErrors } from './utilities/rollbar'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
initializeAuth(pinia)

app.use(VueQueryPlugin, { queryClient })

app.use(Alert)
app.use(Affix)
app.use(Avatar)
app.use(AutoComplete)
app.use(Badge)
app.use(Breadcrumb)
app.use(Button)
app.use(Card)
app.use(Checkbox)
app.use(ConfigProvider)
app.use(Collapse)
app.use(DatePicker)
app.use(Divider)
app.use(Drawer)
app.use(Dropdown)
app.use(Empty)
app.use(FloatButton)
app.use(Form)
app.use(Flex)
app.use(Image)
app.use(Input)
app.use(InputNumber)
app.use(Modal)
app.use(Menu)
app.use(Pagination)
app.use(Popconfirm)
app.use(Popover)
app.use(Progress)
app.use(Radio)
app.use(Segmented)
app.use(Select)
app.use(Slider)
app.use(Skeleton)
app.use(Spin)
app.use(Switch)
app.use(Steps)
app.use(Timeline)
app.use(Tooltip)
app.use(Tag)
app.use(Table)
app.use(Tabs)
app.use(Tour)
app.use(Tree)
app.use(Typography)
app.use(Upload)

app.use(router)
app.use(useQueryParamPlugin, {})

const ENV = getEnvFromUrl()

app.config.errorHandler = (err, instance, info) => {
  const ignoredError =
    (typeof err === 'string' && ignoredRollbarErrors.some((e) => err.includes(e))) ||
    (err instanceof Error &&
      ignoredRollbarErrors.some(
        (e) => err.name.includes(e) || err.message.includes(e) || err.stack?.includes(e),
      ))

  if (ENV !== 'local' && !ignoredError) {
    rollbar.error(err as LogArgument, { info, instance })
  }
  console.error(err, instance, info)
}

app.mount('#app')
